import React from 'react';
import About from '../components/About';
import Team from '../components/Team';
import Contact from '../components/Contact';

function AboutPage() {
  return (
    <div className="page-transition pt-20">
      {/* Page Header */}
      <section className="py-20 bg-gradient-to-br from-purple-500 to-pink-600 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">About Us</h1>
          <p className="text-xl text-purple-100 max-w-2xl mx-auto">
            Learn more about our journey, mission, and the team behind NestedInfo
          </p>
        </div>
      </section>
      
      <About />
      <Team />
      <Contact />
    </div>
  );
}

export default AboutPage;